import { render } from "./AlzataEditUserDialog.vue?vue&type=template&id=32238c1b"
import script from "./AlzataEditUserDialog.vue?vue&type=script&lang=js"
export * from "./AlzataEditUserDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__